export interface LogoProps {
  /** Pixel size of the square mark. Default 28. */
  size?: number;
  /**
   * Theme variant:
   *  - `dark`  → black mark, for light backgrounds (default)
   *  - `light` → white mark, for dark backgrounds
   * Ignored when `color` is provided.
   */
  mode?: 'dark' | 'light';
  /**
   * Explicit fill color; overrides `mode`. Pass `"currentColor"` to inherit the
   * surrounding text color (recommended for theme-driven UIs).
   */
  color?: string;
  className?: string;
  /** Accessible label / tooltip. Default "Discovr". */
  title?: string;
}

/**
 * Discovr brand mark (the "D"). Recolor via `mode` (`dark` | `light`) or an
 * explicit `color` — e.g. `<Logo color="currentColor" />` to follow CSS text
 * color, or `<Logo mode="light" />` on a dark surface.
 */
export function Logo({ size = 28, mode = 'dark', color, className, title = 'Discovr' }: LogoProps) {
  const fill = color ?? (mode === 'light' ? '#FFFFFF' : '#000000');
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label={title}
      className={className}
    >
      <title>{title}</title>
      <path
        d="M0.0308518 0C0.270996 0.0228457 0.723294 0.010757 0.98134 0.0109156L26.9574 0.0177707C26.9153 0.672719 26.956 1.35345 26.9098 2.01315C26.766 4.0727 26.3743 6.02269 25.763 7.99254C24.7051 11.4315 22.967 14.6227 20.6517 17.3767C20.2076 17.9043 19.5587 18.5855 19.0733 19.0834C18.4524 19.7024 17.805 20.2943 17.1328 20.8573C14.2343 23.2354 10.8712 24.9821 7.25867 25.9856C4.72598 26.6942 2.64502 26.952 0.0199607 26.9471C0.0459482 24.9592 0.0100896 22.863 0.0101935 20.863L0.00891388 7.02047C0.00882365 4.703 -0.0217439 2.30778 0.0308518 0Z"
        fill={fill}
      />
      <path
        d="M26.425 17.4169C26.6395 17.4027 26.8212 17.4174 27.0359 17.4307C27.005 18.1808 27.0162 18.9833 27.0165 19.7369V25.6341C27.0167 26.0133 27.0009 26.6464 27.034 27.0092L18.0677 27.0223L17.4062 27.0321C17.4042 21.8784 21.2738 17.7441 26.425 17.4169Z"
        fill={fill}
      />
    </svg>
  );
}
